import React, { useMemo } from 'react'

import OfferMapContainer from '../OfferMap'
import { FLASH_OFFERS_TYPES } from 'constants/offerList'
import Heading from 'components/Luxkit/Typography/Heading'
import useOfferList from 'hooks/Offers/useOfferList'
import { useAppSelector } from 'hooks/reduxHooks'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'

interface Props {
  filters: App.OfferListFilters;
  title: string;
  hash: string;
  key: string;
}

const formatString = (text: string, variable: string, value: string): string => text.replace(variable, value)

function OfferMap(props: Props) {
  const offerList = useOfferList({
    ...props.filters,
    offerTypes: FLASH_OFFERS_TYPES,
  })

  const offerState = useAppSelector(state => state.offer.offers)

  const offers = useMemo(() => {
    return offerList.offerIds.map(id => offerState[id]).filter(Boolean)
  }, [offerList.offerIds, offerState])

  if (offerList.fetching || offerList.offerIds.length === 0) {
    return null
  }

  return <VerticalSpacer gap={40}>
    <Heading variant="heading3" as="h2" align="center">
      {formatString(props.title, '{{numberOfEscapes}}', offerList.offerIds.length.toString())}
    </Heading>
    <OfferMapContainer
      filters={props.filters}
      offers={offers}
      loaded={!offerList.fetching}
      showCarousel
    />
  </VerticalSpacer>
}

export default OfferMap
